module.exports = require('./helpers/bundle-url').getBundleURL('kwCuI') + "annotation-severity-medium-icon.02bebc0c.svg";